import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { menuFooterSizeMixin, withIconSizeMixin } from "../MenuFooter.mixins";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      cursor: default;\n    "])), t.menuFooterColor);
  },
  rootSmall: function rootSmall(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), menuFooterSizeMixin(t.menuFooterPaddingXSmall, t.menuFooterFontSizeSmall, t.menuFooterLineHeightSmall, t.menuFooterPaddingTopSmall, t.menuFooterPaddingBottomSmall));
  },
  rootMedium: function rootMedium(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), menuFooterSizeMixin(t.menuFooterPaddingXMedium, t.menuFooterFontSizeMedium, t.menuFooterLineHeightMedium, t.menuFooterPaddingTopMedium, t.menuFooterPaddingBottomMedium));
  },
  rootLarge: function rootLarge(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), menuFooterSizeMixin(t.menuFooterPaddingXLarge, t.menuFooterFontSizeLarge, t.menuFooterLineHeightLarge, t.menuFooterPaddingTopLarge, t.menuFooterPaddingBottomLarge));
  },
  withLeftPaddingSmall: function withLeftPaddingSmall(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      ", "\n    "])), withIconSizeMixin(t.menuItemPaddingForIconSmall));
  },
  withLeftPaddingMedium: function withLeftPaddingMedium(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      ", "\n    "])), withIconSizeMixin(t.menuItemPaddingForIconMedium));
  },
  withLeftPaddingLarge: function withLeftPaddingLarge(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      ", "\n    "])), withIconSizeMixin(t.menuItemPaddingForIconLarge));
  }
});